import { useApiProblem } from '@/shared/api/useApiProblem';

export function PluginProblem({ error }: { error: unknown }) {
  const problem = useApiProblem(error);
  if (!error) return null;
  return (
    <p role="alert" className="text-sealwax border-sealwax/20 rounded-md border p-4 text-sm">
      {problem?.status === 0
        ? 'Die Antwort fehlt. Möglicherweise wurde gespeichert. Prüfen Sie den neu geladenen Stand, bevor Sie es erneut versuchen.'
        : problem?.detail || problem?.title || 'Die Anfrage konnte nicht abgeschlossen werden.'}
    </p>
  );
}
